export const SYSTEM_MASTERS = [
    "department",
    "document-category",
    "document-status",
    "document-type",
    "employee-designation",
    "employee-type",
    "grievance-type",
    "lead-source",
    "leave-type",
    "party-role",
    "product-brand",
    "product-category",
    "product-uom",
    "task-status",
    'vendor-category',
    "tender-type",
]




  
